import React, { memo } from 'react'
import { Box, Skeleton } from 'transfix-ui/core'
import * as Types from 'apps/fleet-planner/types'
import { Avatar } from 'transfix-ui'

interface ITeamMemberName {
  /**
   * Team member to be displayed
   */
  teamMember: Types.ITeamMember
}

export const TeamMemberName = memo<ITeamMemberName>(({ teamMember = {} }) => (
  <Box display='flex' alignItems='center'>
    <Box mr={1.5}>
      <Avatar key={teamMember?.id} name={`${teamMember.firstName} ${teamMember?.lastName}`} />
    </Box>
    <Box mr={1.5}>
      <div>
        {teamMember?.firstName} {teamMember.lastName}
      </div>
      <div className='text-secondary fs-mask'>{teamMember?.email}</div>
    </Box>
  </Box>
))

export const TeamMemberNameSkeleton = () => (
  <Box display='flex' alignItems='center'>
    <Box mr={1.5}>
      <Skeleton variant='circular' animation='wave' width={32} height={32} />
    </Box>
    <Box mr={1.5}>
      <Skeleton variant='text' animation='wave' width='125px' height='19px' />
      <Skeleton variant='text' animation='wave' width='150px' height='19px' />
    </Box>
  </Box>
)
